import { caseOfEmergency } from '../../../../../img/images';
import { InstructionTickIcon } from '../../../../shared/icons/icons';
import { ILocalization } from '../../../../../localization/definitions/types';

export const EmergencyCaseSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='emergency-case-slide'>
                <img alt='' src={caseOfEmergency} />
            </div>
        </div>
    );
};

export const EmergencyCaseSlideImageSrc = caseOfEmergency;

interface Props {
    localization: ILocalization;
}

export const EmergencyCaseSlideContent = ({ localization }: Props) => {
    const { emergencyCaseSlide } =
        localization.localizationStrings.susy.thesisManagement.tutorial.user
            .slides;

    return (
        <div className='tutorial-content-wrapper'>
            <h1>{emergencyCaseSlide.inCaseOf}​​​</h1>
            <h4>{emergencyCaseSlide.dontPanic}​</h4>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {emergencyCaseSlide.withdrawYourProject}
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {emergencyCaseSlide.requestAnExtension}
                </div>
            </div>
        </div>
    );
};
